<template>
  <div>
    <h1>Access Denied</h1>
    <p>You must be logged in to view this page.</p>
    <router-link to="/">Go to Home</router-link>
  </div>
</template>
<script>
export default {
  name: 'AccessDenied'
}
</script>
<style scoped>
/* Add any styles you need */
</style>
